export const SALE_DISRIBUTION_EXPORT_ID = "sales-distribution";

export const SALE_DISTRIBUTION_EXPORT_TITLE = "Distribución de Ventas";

export const LOCALIZED_PROPERTIES = {
  code: "Cod. Pagador",
  client: "Pagador",
  codeDelivery: "Cod. Receptor",
  delivery: "Receptor",
  codeMaterial: "Cod. Material",
  material: "Material",
  um: "U.M.",
  price: "Precio",
  amountRequest: "Cnt. Solicitada",
  amountSeved: "Cnt. Atendida",
};
